/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Still_Loud_Stork_LeapInputs */

const en_still_loud_stork_leap = /** @type {(inputs: Still_Loud_Stork_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reactivate Token`)
};

const de_still_loud_stork_leap = /** @type {(inputs: Still_Loud_Stork_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token reaktivieren`)
};

/**
* | output |
* | --- |
* | "Reactivate Token" |
*
* @param {Still_Loud_Stork_LeapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const still_loud_stork_leap = /** @type {((inputs?: Still_Loud_Stork_LeapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Still_Loud_Stork_LeapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_still_loud_stork_leap(inputs)
	return de_still_loud_stork_leap(inputs)
});